import api from "./api";

const reportTemplatesService = {
  list: async () => {
    const res = await api.getSavedViews({ is_report_template: 1 });
    return Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
  },

  get: async (id) => {
    const res = await api.getSavedView(id);
    return res?.data && res.data.id ? res.data : res;
  },

  create: async ({ name, payload }) => {
    const res = await api.createSavedView({
      name,
      entity: "leads",
      payload,
      isReportTemplate: true,
      isDefault: false,
    });
    return res?.data && res.data.id ? res.data : res;
  },

  update: async (id, { name, payload }) => {
    const res = await api.updateSavedView(id, { name, payload });
    return res?.data && res.data.id ? res.data : res;
  },

  remove: async (id) => api.deleteSavedView(id),

  preview: async ({ payload, filters, limit = 50 }) =>
    api.previewReportTemplate({ payload, filters, limit }),

  downloadSample: async (id, format = "xlsx") =>
    api.downloadSavedViewSample(id, format),
};

export default reportTemplatesService;